import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import Dropzone from 'react-dropzone';
import fileDownload from 'react-file-download';
import Alert from 'components/ui/Alert';
import { uploadBulkConsigneeCSVFile } from 'utils/UserWebAPIUtils';
import { useTranslation, withTranslation } from 'react-i18next';
import FormCard from '../../v2/FormCard';
import CargomaticInput from '../../v2/input';
import UserActionCreators from '../../../actions/UserActionCreators';
import PhoneField from 'components/v2/forms/PhoneField';
const consigneeTemplate = 'company_name,first_name,last_name,email,phone\n,,,,';
const getEmptyState = () => {
    return {
        creatingConsignees: false,
        showInvalidFileType: false,
        consignee: {
            company_name: '',
            email: '',
            first_name: '',
            last_name: '',
            password: '',
            phone: '',
        },
    };
};
const ORComponent = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "flex" },
        React.createElement("div", { className: "w-1/2 border-b border-solid" }, "\u00A0"),
        React.createElement("div", { className: "px-2 m-0 -mb-7 align-bottom" },
            React.createElement("h4", { className: "text-lg font-medium text-gray-700 leading-6" }, t('OR'))),
        React.createElement("div", { className: "w-1/2 border-b border-solid" }, "\u00A0")));
};
class RegisterConsignee extends Component {
    constructor(props) {
        super(props);
        this.handleChange = (field) => (value) => {
            this.setState((prevState) => {
                return {
                    consignee: Object.assign(Object.assign({}, prevState.consignee), { [field]: value }),
                };
            });
        };
        this.handleRegister = (e) => {
            e.preventDefault();
            const { consignee } = this.state;
            UserActionCreators.addConsignee(Object.assign({}, consignee));
            this.setState(getEmptyState());
        };
        this.onFileDrop = (files) => {
            if (!files || !files.length) {
                return this.setState({ showInvalidFileType: true });
            }
            this.setState({ creatingConsignees: true, showInvalidFileType: false }, async () => {
                await uploadBulkConsigneeCSVFile(files[0]).catch((e) => {
                    console.log('Error', e);
                });
                this.setState({ creatingConsignees: false });
            });
        };
        this.state = getEmptyState();
    }
    render() {
        const { consignee, showInvalidFileType, creatingConsignees } = this.state;
        const { t } = this.props;
        const disabled = isEmpty(consignee.company_name) ||
            isEmpty(consignee.email) ||
            isEmpty(consignee.first_name) ||
            isEmpty(consignee.last_name) ||
            isEmpty(consignee.password) ||
            isEmpty(consignee.phone);
        return (React.createElement(FormCard, { actions: () => (React.createElement("button", { disabled: disabled, className: "button button-green", type: "submit", onClick: this.handleRegister }, t('REGISTER_CONSIGNEE'))) },
            React.createElement("div", null,
                React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" },
                    t('CONSIGNEE_REGISTRATION'),
                    React.createElement("span", { className: "text-green px-1 cursor-pointer", onClick: () => fileDownload(consigneeTemplate, 'consignee-template.csv') },
                        React.createElement("i", { className: "fa fa-download" }))),
                React.createElement(Dropzone, { className: "w-full h-24 border border-green border-6 border-dashed rounded p-4", onDrop: this.onFileDrop, accept: "text/csv", multiple: false },
                    !creatingConsignees && !showInvalidFileType && (React.createElement("label", { className: "form-label" }, t('CLICK_OR_DRAG_TO_UPLOAD_FILE'))),
                    showInvalidFileType && (React.createElement(Alert, { type: "error" }, t('INVALID_FILE_TYPE_UPLOAD_CSV'))),
                    creatingConsignees && (React.createElement("span", null,
                        t('PROCESSING_CONSIGNEES'),
                        React.createElement("i", { className: "fa fa-spinner fa-spin text-green px-2" }))))),
            React.createElement("div", { className: "py-2" },
                React.createElement(ORComponent, null)),
            React.createElement("div", { className: "mb-4" },
                React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" }, t('CREATE_CONSIGNEE'))),
            React.createElement("div", { className: "grid grid-cols-4 gap-6" },
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "text", value: consignee.first_name, label: t('FIRST_NAME'), placeholder: t('FIRST_NAME'), onChange: this.handleChange('first_name') })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "text", value: consignee.last_name, label: t('LAST_NAME'), placeholder: t('LAST_NAME'), onChange: this.handleChange('last_name') })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "text", value: consignee.company_name, label: t('COMPANY_NAME'), placeholder: t('COMPANY_NAME'), onChange: this.handleChange('company_name') })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "phone", value: consignee.phone, label: t('PHONE'), placeholder: t('PHONE'), onChange: this.handleChange('phone') })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "email", value: consignee.email, label: t('EMAIL'), placeholder: t('EMAIL'), onChange: this.handleChange('email') })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement(CargomaticInput, { className: "mb-4", type: "password", placeholder: t('PASSWORD'), value: consignee.password, label: t('PASSWORD'), onChange: this.handleChange('password') })))));
    }
}
export default withTranslation()(RegisterConsignee);
